module.exports = __webpack_public_path__ + "static/tree1@2x-a10bf3ab583fa61f0a955973a31846fc.png";